import { useMutation, useQuery } from 'react-query';
import { omitBy, isNil } from 'lodash';

import { request } from '@/utils';

import { UserDetailRes } from '../useUser';

export type UserBaseDetailRes = {
  id: string;
  account_id?: string;
  comment?: string;
  avatar?: UserDetailRes['avatar'];
  create_at: number;
  is_following: boolean;
  is_mine: boolean;
  email?: string;
  email_verified?: boolean;
  twitter_id?: string;
  twitter_id_verified?: boolean;
  github_id?: string;
  github_id_verified?: boolean;
  market_status: UserDetailRes['market_status'];
};

export const useFollowMutation = (addr: string) => {
  const mutation = useMutation(
    ({
      isFollowing,
      ...rest
    }: {
      isFollowing: boolean;
      [key: string]: number | string | boolean;
    }) => {
      return request.post<{ is_success: boolean }>(
        `/user/${isFollowing ? 'unfollow_v2' : 'follow_v2'}`,
        {
          to_id: addr,
          ...omitBy(rest, isNil),
        },
      );
    },
  );

  return mutation;
};

export const useUserDescDict = (ids: string[], enabled?: boolean) => {
  return useQuery(
    ['/user/desc_dict', ids.join(',')],
    () => {
      if (ids.length === 0) {
        return { desc_dict: {} } as {
          desc_dict: Record<string, UserDesc>;
        };
      }
      return request.get<{
        desc_dict: Record<string, UserDesc>;
      }>('/user/desc_dict', {
        ids: ids.join(','),
      });
    },
    {
      keepPreviousData: true,
      enabled,
    },
  );
};
